@use "@fukuri-admins/ui/layout" as *;

// アップロード状況テーブル列スタイル
.uploadStatusCol     { width: 112px; }
.receptNoCol         { width: 112px; }
.errorContentCol     { min-width: 320px; }
.registeredCountCol  { width: 104px; }
.scheduledAtCol      { width: 160px; }
.actionCol           { width: 128px; }

// エラー内容セル（一部失敗・失敗）。Table 既定の nowrap を解除し長文を折り返す
.errorContent {
  color: text('Red');
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}

// アップロードデータが 0 件のときの Empty 表示
.empty {
  display: flex;
  flex: 1;
  color: text('Low');
  @include typography('Jp/16_W3');

  > span {
    margin: auto;
  }
}

.helpList {
  margin: 0;
  padding: 0;
  list-style: none;

  > li {
    padding-left: 1em;
    text-indent: -1em;
  }
}
